import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { FloodVortexTutorialState } from './FloodTutorialAdapter.js';

type VState = FloodVortexTutorialState;

const PARTIAL = 'D,C1D1,C1C2,A2B2';
const PARTIAL_GATED = `${PARTIAL}|C0=B3`;
const SOLVED = 'D,A2A3,C1D1,C1C2,A2B2,B1B2,A1B1|C0=B3';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { flood: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'C2', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'B5', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { flood: PARTIAL },
                { flood: PARTIAL, gateMode: true },
                { flood: PARTIAL_GATED, gateMode: true },
                { flood: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle the pair active (flood pieces never block a gate)
    {
        gameState: { flood: 'D', gateMode: true } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'B2', anchor: 'center', color: COLORS.teal },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { flood: 'D', gateMode: true },
                { flood: 'D|C0=B3', gateMode: true },
            ] as VState[],
        },
    },

    // Scene 3: Water teleportation
    {
        gameState: { flood: PARTIAL_GATED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Water enters\na gate...', cell: 'C0', anchor: 'far-left' },
            { type: 'text-label', text: '...exits from\nthe other side', cell: 'B3', anchor: 'far-right' },
            { type: 'pulse', cell: 'C0', color: COLORS.purple },
            { type: 'pulse', cell: 'B3', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state
    {
        gameState: { flood: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Do not worry\nabout loops', cell: 'D3', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'C0', color: COLORS.purple },
            { type: 'pulse', cell: 'B3', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Flood tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches water teleportation through Vortex gates.
 */
export const FLOOD_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'flood-vortex',
    gridCode: '6/0-3:0C4,1C1,2A2,3F3',
    scenes,
    previewScene: 3,
};
